import { gql } from '@apollo/client';

export const contractGql = gql`
  query contract($id: String!) {
    contract(id: $id) {
      _id
      category
      ospContractId
      startDate
      stopDate
      isEnabled
      contractCount
      spacesAllocated
      presenceCounter
      name1
      name2
      lang
      parkingId
      description
      isInside
      reference
      spacesOccupied
      productId
      username
      product {
        rules {
          credentialsTypes {
            types {
              type
              provider
            }
          }
        }
        externalPayload {
          ArticleCodes {
            code
            status
          }
        }
      }
      dateBoundaryFromParent {
        from
        to
      }
      articleCode
      motoristId

      address {
        address1
        address2
        city
        country
        zipcode
      }

      credentials {
        _id
        type
        provider
        value
        description
      }

      poolUsers {
        _id
        firstName
        lastName
        username
      }

      freeflag {
        _id
      }

      rules

      qrcode {
        createdAt
      }
    }
  }
`;
